import { Badge } from "@/components/ui/badge";

export const FIT = {
  ok: { label: "Taglia OK", cls: "border-emerald-500/50 text-emerald-400" },
  limite: { label: "Al limite", cls: "border-amber-500/50 text-amber-400" },
  controllare: { label: "Controllare", cls: "border-rose-500/50 text-rose-400" },
};

export const FitBadge = ({ fit, size, testid }) => {
  if (!fit) return null;
  return (
    <div className="mt-1" data-testid={testid}>
      <Badge variant="outline" className={`text-[10px] ${FIT[fit.status].cls}`}>{FIT[fit.status].label}</Badge>
      {fit.band && <span className="ml-1.5 text-[10px] text-muted-foreground">fascia altezza {fit.band}</span>}
      {fit.issues.map((i) => (
        <p key={i.measure} className="mt-0.5 text-[11px] text-muted-foreground">
          {i.measure} {i.value} cm: la {size} va da {i.min ?? "–"} a {i.max ?? "–"} ({i.diff} cm fuori)
        </p>
      ))}
      {fit.suggestion && <p className="text-[11px] text-primary">Prova la {fit.suggestion}</p>}
    </div>
  );
};
